<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
            <v-col cols="12" md="4">
                <v-card class="elevation-2">
                    <v-card-title>Nuovi vs Ricorrenti</v-card-title>
                    <v-card-text>
                        <doughnut-chart :data="graficoNuoviRicorrenti" :options="opzioniTorta" :key="keyNuovi" />
                    </v-card-text>
                    <v-divider />
                    <v-card-text>
                        <v-row class="ma-0 pa-0">
                            <v-col cols="6" class="text-center">
                                <div class="text-h6 success--text">{{ numeroNuovi }}</div>
                                <div class="text-caption">Nuovi Clienti</div>
                            </v-col>
                            <v-col cols="6" class="text-center">
                                <div class="text-h6 primary--text">{{ numeroRicorrenti }}</div>
                                <div class="text-caption">Ricorrenti</div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="8">
                <v-card class="elevation-2">
                    <v-card-title>Tasso di Retention Clienti</v-card-title>
                    <v-card-text>
                        <line-chart :data="graficoRetention" :options="opzioniLinea" :key="keyRetention" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0 mt-3">
            <v-col cols="12">
                <v-card class="elevation-2">
                    <v-card-title>
                        Clienti a Rischio
                        <v-spacer />
                        <v-chip color="error" small>{{ clientiRischio.length }} clienti</v-chip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon small class="ml-2" v-on="on">info</v-icon>
                            </template>
                            <span>Clienti senza fatture da oltre 60 giorni o con fatturato in calo di oltre il 30%
                                rispetto allo stesso periodo dell'anno precedente (compresi i clienti che hanno
                                fatturato solo l'anno scorso)</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="intestazioniRischio" :items="clientiRischio" :items-per-page="10" dense
                            class="elevation-1">
                            <template v-slot:item.ultimaFattura="{ item }">
                                <v-chip small :color="getColoreGiorni(item.giorniDa)">
                                    {{ item.giorniDa }} giorni fa
                                </v-chip>
                            </template>
                            <template v-slot:item.tendenza="{ item }">
                                <div class="d-flex align-center">
                                    <v-icon small :color="item.tendenza < 0 ? 'error' : 'success'">
                                        {{ item.tendenza >= 0 ? 'trending_up' : 'trending_down' }}</v-icon>
                                    <span :class="item.tendenza < 0 ? 'error--text' : 'success--text'" class="ml-1">
                                        {{ Math.abs(item.tendenza).toFixed(1) }}%
                                    </span>
                                </div>
                            </template>
                            <template v-slot:item.fatturato="{ item }">
                                € {{ $functions.numberWithCommas(item.fatturato.toFixed(2)) }}
                            </template>
                            <template v-slot:item.azioni="{ item }">
                                <v-btn icon small @click="visualizzaDettaglio(item)">
                                    <v-icon small>visibility</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0 mt-3">
            <v-col cols="12" md="6">
                <v-card class="elevation-2">
                    <v-card-title>Frequenza Ordini per Cliente</v-card-title>
                    <v-card-text>
                        <bar-chart :data="graficoFrequenza" :options="opzioniBarre" :key="keyFrequenza" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="6">
                <v-card class="elevation-2">
                    <v-card-title>Distribuzione Valore Medio Fattura</v-card-title>
                    <v-card-text>
                        <bar-chart :data="graficoValoreMedio" :options="opzioniBarre" :key="keyValore" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Dialog dettaglio cliente -->
        <v-dialog v-model="dialogDettaglio" max-width="800px">
            <v-card>
                <v-card-title>
                    Dettaglio Cliente: {{ clienteSelezionato.nome }}
                    <v-spacer />
                    <v-btn icon @click="dialogDettaglio = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <div class="text-caption">Fatturato Anno Corrente</div>
                            <div class="text-h6">€ {{ $functions.numberWithCommas(clienteSelezionato.fatturato) }}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-caption">Ultima Fattura</div>
                            <div class="text-h6">{{ clienteSelezionato.dataUltima }}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-caption">Numero Fatture</div>
                            <div class="text-h6">{{ clienteSelezionato.numeroFatture }}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-caption">Valore Medio</div>
                            <div class="text-h6">€ {{ $functions.numberWithCommas(clienteSelezionato.valoreMedio) }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="apriScheda">Apri Scheda Cliente</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { get_data } from "@/api/api.documenti.js";
import DoughnutChart from "@/components/chart/DoughnutChart.js";
import LineChart from "@/components/chart/LineChart.js";
import BarChart from "@/components/chart/BarChart.js";
import mixinCharts from "@/components/chart/mixinCharts.js";

export default {
    name: "TabAnalisiClienti",

    components: {
        DoughnutChart,
        LineChart,
        BarChart
    },

    mixins: [mixinCharts],

    props: {
        filtri: { type: Object, default: () => ({}) },
        aggiornaDati: { type: Number, default: 0 }
    },

    data: () => ({
        graficoNuoviRicorrenti: {},
        graficoRetention: {},
        graficoFrequenza: {},
        graficoValoreMedio: {},

        opzioniTorta: {},
        opzioniLinea: {},
        opzioniBarre: {},

        keyNuovi: 0,
        keyRetention: 0,
        keyFrequenza: 0,
        keyValore: 0,

        numeroNuovi: 0,
        numeroRicorrenti: 0,

        intestazioniRischio: [
            { text: 'Cliente', value: 'nome' },
            { text: 'Motivo', value: 'motivo' },
            { text: 'Ultima Fattura', value: 'ultimaFattura', align: 'center' },
            { text: 'Tendenza', value: 'tendenza', align: 'center' },
            { text: 'Fatturato Annuo', value: 'fatturato', align: 'end' },
            { text: 'Azioni', value: 'azioni', align: 'center', sortable: false }
        ],

        clientiRischio: [],

        dialogDettaglio: false,
        clienteSelezionato: {
            nome: '',
            fatturato: 0,
            dataUltima: '',
            numeroFatture: 0,
            valoreMedio: 0
        }
    }),

    methods: {
        async caricaDatiNuoviRicorrenti() {
            try {
                let res = await get_data("fatture/nuovi-ricorrenti", this.filtri);

                if (res && res.data) {
                    this.numeroNuovi = res.data.nuovi.numero;
                    this.numeroRicorrenti = res.data.ricorrenti.numero;

                    this.graficoNuoviRicorrenti = {
                        labels: ['Nuovi Clienti', 'Clienti Ricorrenti'],
                        datasets: [{
                            data: [res.data.nuovi.fatturato, res.data.ricorrenti.fatturato],
                            backgroundColor: ['#4CAF50', '#2196F3']
                        }]
                    };

                    this.keyNuovi++;
                }

            } catch (error) {
                console.error("Errore caricamento nuovi/ricorrenti:", error);
            }
        },

        async caricaDatiRetention() {
            try {
                let res = await get_data("fatture/retention", this.filtri);

                if (res && res.data) {
                    this.graficoRetention = {
                        labels: res.data.anni,
                        datasets: [{
                            label: 'Tasso di Retention %',
                            data: res.data.percentuali,
                            fill: false,
                            borderColor: '#4CAF50',
                            backgroundColor: '#4CAF50',
                            borderWidth: 3,
                            tension: 0.4,
                            pointRadius: 5,
                            pointHoverRadius: 7
                        }]
                    };

                    this.keyRetention++;
                }

            } catch (error) {
                console.error("Errore caricamento retention:", error);
            }
        },

        async caricaDatiClientiRischio() {
            try {
                let res = await get_data("fatture/clienti-rischio", this.filtri);

                if (res && res.data) {
                    this.clientiRischio = res.data.map(cliente => ({
                        nome: cliente.ragSoc,
                        motivo: cliente.motivo,
                        ultimaFattura: this.$i2kFunctions.formatISODate(cliente.dataUltimaFattura),
                        giorniDa: cliente.giorniDaUltimaFattura,
                        tendenza: cliente.tendenzaFatturato,
                        fatturato: cliente.fatturatoAnnuo,
                        codice: cliente.codAnagrafica
                    }));
                }

            } catch (error) {
                console.error("Errore caricamento clienti a rischio:", error);
            }
        },

        async caricaDatiFrequenza() {
            try {
                let res = await get_data("fatture/frequenza-ordini", this.filtri);

                if (res && res.data) {
                    this.graficoFrequenza = {
                        labels: res.data.categorie, // es: ['1-2 ordini', '3-5 ordini', '6-10 ordini', '>10 ordini']
                        datasets: [{
                            label: 'Numero Clienti',
                            data: res.data.valori,
                            backgroundColor: 'rgba(33, 150, 243, 0.7)',
                            borderColor: 'rgba(33, 150, 243, 1)',
                            borderWidth: 2
                        }]
                    };

                    this.keyFrequenza++;
                }

            } catch (error) {
                console.error("Errore caricamento frequenza:", error);
            }
        },

        async caricaDatiValoreMedio() {
            try {
                let res = await get_data("fatture/valore-medio", this.filtri);

                if (res && res.data) {
                    this.graficoValoreMedio = {
                        labels: res.data.fasce, // es: ['< 500€', '500-1000€', '1000-2000€', '> 2000€']
                        datasets: [{
                            label: 'Numero Clienti',
                            data: res.data.valori,
                            backgroundColor: 'rgba(255, 152, 0, 0.7)',
                            borderColor: 'rgba(255, 152, 0, 1)',
                            borderWidth: 2
                        }]
                    };

                    this.keyValore++;
                }

            } catch (error) {
                console.error("Errore caricamento valore medio:", error);
            }
        },

        getColoreGiorni(giorni) {
            if (giorni > 90) return 'error';
            if (giorni > 60) return 'warning';
            return 'success';
        },

        visualizzaDettaglio(cliente) {
            this.clienteSelezionato = {
                nome: cliente.nome,
                fatturato: cliente.fatturato,
                dataUltima: cliente.ultimaFattura,
                numeroFatture: 0, // Da caricare con chiamata API
                valoreMedio: 0,   // Da caricare con chiamata API
                codice: cliente.codice
            };

            // Carica dettagli aggiuntivi
            this.caricaDettaglioCliente(cliente.codice);
            this.dialogDettaglio = true;
        },

        async caricaDettaglioCliente(codice) {
            try {
                let res = await get_data("fatture/dettaglio-cliente/" + codice, this.filtri);

                if (res && res.data) {
                    this.clienteSelezionato.numeroFatture = res.data.numeroFatture;
                    this.clienteSelezionato.valoreMedio = res.data.valoreMedio;
                }

            } catch (error) {
                console.error("Errore caricamento dettaglio cliente:", error);
            }
        },

        apriScheda() {
            // Naviga alla scheda cliente
            this.$router.push({
                name: 'Cliente',
                params: { id: this.clienteSelezionato.codice }
            });
        },

        caricaTuttiDati() {
            this.caricaDatiNuoviRicorrenti();
            this.caricaDatiRetention();
            this.caricaDatiClientiRischio();
            this.caricaDatiFrequenza();
            this.caricaDatiValoreMedio();
        }
    },

    mounted() {
        this.opzioniTorta = this.getOptionsDoughnutChart();
        this.opzioniLinea = this.getOptionsMixedChart();
        this.opzioniBarre = this.getOptionsMixedChart();
        this.caricaTuttiDati();
    },

    watch: {
        aggiornaDati() {
            this.caricaTuttiDati();
        }
    }
}
</script>